import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cream px-6">
      <Card className="w-full max-w-md">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2 items-center">
            <AlertCircle className="h-8 w-8 text-coral" />
            <h1 className="text-2xl font-display font-bold text-navy">
              Page introuvable
            </h1>
          </div>
          <p className="mt-2 text-sm text-navy/60">
            La page demandée n'existe pas ou a été déplacée.
          </p>
          <Link
            href="/"
            className="inline-block mt-6 bg-coral text-white px-5 py-2 rounded-full font-bold text-sm hover:bg-[#d16b50] transition-colors"
          >
            Retour à l'accueil
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
